import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTag } from 'src/components/CustomTag';
import { TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { PresetToneOfVoiceIcon } from 'src/components/PresetToneOfVoiceIcon';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { getCustomModelTexts } from 'src/data/customModel';
import {
  DEFAULT_SUGGEST_TOV_MODE,
  DRAFT_TOV_ID,
  formatToneOfVoiceDescription,
  getToneOfVoiceTitle,
  getTovTexts,
} from 'src/data/toneOfVoice';

import { useStyles } from './useStyles';

export const ToneOfVoiceLabel = ({
  classes,
  toneOfVoices,
  customModels,
  selectedTov,
  selectedCustomModelId,
  draftToneOfVoice,
  disabled,
  language,
}) => {
  const styles = useStyles({ classes });

  const { customModelTitle, customModelLabel } = getCustomModelTexts(
    selectedCustomModelId,
    customModels
  );

  const { tovLabel, tovTitle } = getTovTexts(selectedTov, toneOfVoices, language);

  const isDraftTov = selectedTov === DRAFT_TOV_ID && draftToneOfVoice;

  const title = isDraftTov
    ? formatToneOfVoiceDescription(draftToneOfVoice, false, language)
    : customModelTitle || getToneOfVoiceTitle(selectedTov, language) || tovTitle;
  const label = customModelLabel || tovLabel;

  return (
    <div
      className={cx(styles.root, { [styles.disabledText]: disabled })}
      title={`${title} ${label ? `(${label})` : ''}`}
    >
      {selectedTov && (
        <PresetToneOfVoiceIcon
          className={cx(styles.icon, { [styles.disabledText]: disabled })}
          presetTov={selectedTov}
        />
      )}
      <TruncatedTypography
        variant={TYPOGRAPHY_VARIANT.regular14}
        className={!label && !selectedTov ? styles.emptyLabel : null}
      >
        {title || 'Select...'}
      </TruncatedTypography>
      {label && (
        <TruncatedTypography
          className={cx(styles.label, { [styles.disabledText]: disabled })}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          ({label})
        </TruncatedTypography>
      )}
      <CustomTag
        className={cx(styles.tag, { [styles.customModelTag]: !!customModelLabel })}
        tag={customModelLabel ? 'Custom model' : isDraftTov ? 'Draft' : ''}
      />
    </div>
  );
};

ToneOfVoiceLabel.propTypes = {
  classes: PropTypes.shape({}),
  customModels: PropTypes.arrayOf(PropTypes.shape({})),
  toneOfVoices: PropTypes.arrayOf(PropTypes.shape({})),
  selectedTov: PropTypes.string,
  selectedCustomModelId: PropTypes.string,
  draftToneOfVoice: PropTypes.shape({}),
  disabled: PropTypes.bool,
};
ToneOfVoiceLabel.defaultProps = {
  classes: null,
  customModels: [],
  toneOfVoices: [],
  selectedTov: DEFAULT_SUGGEST_TOV_MODE,
  selectedCustomModelId: null,
  draftToneOfVoice: null,
  disabled: false,
};
